import React from 'react';
import useSafeAreaInsets from '@root/hooks/useSafeAreaInsets';
import { isInApp } from '@root/shared';

const SafeAreaInset = ({
  position = 'bottom',
  extraHeight = 0,
}: {
  position?: 'top' | 'bottom';
  extraHeight?: number;
}) => {
  const safeAreaInsets = useSafeAreaInsets();

  if (!isInApp) {
    return null;
  }

  // 旧版本的无法注入 JsBridge 取不到安全区域 默认加上 12px
  const height = window.WebViewJavascriptBridge
    ? safeAreaInsets[position] + extraHeight
    : 12;

  return <div style={{ height }} />;
};

export default SafeAreaInset;
